import { Injectable, TemplateRef } from '@angular/core';
import { CampusFile, FileType } from 'src/openapi';
import { VimeoService } from '../shared/services/vimeo.service';
import { YoutubeService } from '../shared/services/youtube.service';

export type Video = any & {
  showVideo: () => void;
  videoLoaded: ({ success: string, error: boolean }) => void;
};

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  videoContainer: Video;

  constructor(
    private vimeoService: VimeoService,
    private youtubeService: YoutubeService,
  ) {}

  showVideo(
    videoFile: CampusFile
  ) {
    const openVideo = this.loadEmbed(videoFile);

    if (openVideo) {
      this.videoContainer.showVideo();
    }
  }

  registerVideoContainer(videoContainer: Video) {
    this.videoContainer = videoContainer;
  }

  private loadEmbed(videoFile: CampusFile) : boolean {
    switch (videoFile.type) {
      case FileType.Vimeo:
        this.vimeoService.getVimeoEmbed(videoFile.url).subscribe({
          next: (response) => {
            this.videoContainer.videoLoaded({ success: response.data.getVimeoEmbed.html, error: false });
          },
          error: (error) => {
            this.videoContainer.videoLoaded({ success: undefined, error: true });
          }
        });

        return true;

      case FileType.Youtube:
        this.youtubeService.getYoutubeEmbed(videoFile.url).subscribe({
          next: (response) => {
            this.videoContainer.videoLoaded({ success: response.data.getYoutubeEmbed.html, error: false });
          },
          error: (error) => {
            this.videoContainer.videoLoaded({ success: undefined, error: true });
          }
        });

        return true;

      case FileType.Default:
        window.open(videoFile.url);

        return false;

      default:
        return false;
    }
  }
}
